import React, { FC, PropsWithChildren } from 'react';

type ArrowRightLongProps = {
  /** The color of the icon. */
  color?: string;
};

const ArrowRightLong: FC<PropsWithChildren<ArrowRightLongProps>> = ({ color = 'currentcolor' }) => (
  <svg height="16" viewBox="1.07 1.919 497.652 226.501" width="32">
    <path
      d="M 15.827 0.611 L 11.3 5.138 C 11.08 5.359 10.792 5.469 10.5 5.469 C 10.209 5.469 9.921 5.359 9.699 5.138 C 9.257 4.696 9.257 3.981 9.699 3.538 L 12.294 0.942 L -7.578 0.942 C -8.201 0.942 -8.709 0.439 -8.709 -0.189 C -8.709 -0.818 -8.201 -1.321 -7.578 -1.321 L 12.294 -1.321 L 9.699 -3.917 C 9.257 -4.359 9.257 -5.074 9.699 -5.518 C 10.141 -5.96 10.858 -5.96 11.3 -5.518 L 15.827 -0.99 C 16.27 -0.548 16.27 0.168 15.827 0.611 Z"
      fill={color}
      fillRule="nonzero"
      transform="matrix(20.011559, 0, 0, 20.011559, 175.3508, 118.976921)"
    />
  </svg>
);

export default ArrowRightLong;
